import cn from 'clsx';
import { FC, MouseEvent } from 'react';

import { ButtonModel, ColorPropsType } from '../../../types';
import Icon from '../../Icon';

import s from './BoxButton.module.scss';

export interface BoxButtonProps extends ButtonModel {
  selected?: boolean;
  fullWidth?: boolean;
  forStickyBottom?: boolean;
  forStickyKeyboard?: boolean;
  color?: ColorPropsType;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
}

const ICON_SIZE = {
  small: 17,
  default: 20,
  large: 24
};

const BoxButton: FC<React.PropsWithChildren<BoxButtonProps>> = ({
  size = 'default',
  state = 'basic',
  selected = false,
  fullWidth = false,
  forStickyBottom = false,
  forStickyKeyboard = false,
  loading = false,
  disabled = false,
  className = '',
  color = '',
  icon,
  onClick,
  children,
  ...props
}) => {
  return (
    <button
      type="button"
      className={cn(
        s.button,
        s[size],
        {
          [s[state] as string]: !color,
          [s.text_white as string]: color,
          [s[color] as string]: color,
          [s[`${size}-icon-pl`] as string]: icon && children,
          [s.loading as string]: loading,
          [s.selected as string]: selected,
          [s['full-width'] as string]: fullWidth,
          [s['for-sticky-bottom'] as string]: forStickyBottom,
          [s['for-sticky-keyboard'] as string]: forStickyKeyboard
        },
        className
      )}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
    >
      {icon && (
        <Icon
          className={cn(s.icon, {
            [s.animate as string]: loading
          })}
          type={loading ? 'state-progress' : icon}
          size={ICON_SIZE[size]}
        />
      )}
      {children && <span className={cn(s.text, { [s.transparent as string]: loading && !icon })}>{children}</span>}
      {loading && !icon && (
        <span className={s['loading-icon-area']}>
          <Icon className={s.animate} type="state-progress" size={ICON_SIZE[size]} />
        </span>
      )}
    </button>
  );
};

export default BoxButton;
